/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  ProductDraftsUserControllerCreateMutationRequest,
  ProductDraftsUserControllerCreateMutationResponse,
  ProductDraftsUserControllerCreate400,
  ProductDraftsUserControllerCreate401,
  ProductDraftsUserControllerCreate409,
} from '../../types/ProductDraftsUserControllerCreate.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { productDraftsUserCreate } from '../../methods/productDraftsUserCreate.ts';
import { useMutation } from '@tanstack/react-query';

export const productDraftsUserCreateMutationKey = () => [{ url: '/api/user/product-drafts' }] as const;

export type ProductDraftsUserCreateMutationKey = ReturnType<typeof productDraftsUserCreateMutationKey>;

/**
 * {@link /api/user/product-drafts}
 */
export function useProductDraftsUserCreate<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ProductDraftsUserControllerCreateMutationResponse,
      ResponseErrorConfig<
        | ProductDraftsUserControllerCreate400
        | ProductDraftsUserControllerCreate401
        | ProductDraftsUserControllerCreate409
      >,
      { data?: ProductDraftsUserControllerCreateMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<ProductDraftsUserControllerCreateMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? productDraftsUserCreateMutationKey();

  return useMutation<
    ProductDraftsUserControllerCreateMutationResponse,
    ResponseErrorConfig<
      ProductDraftsUserControllerCreate400 | ProductDraftsUserControllerCreate401 | ProductDraftsUserControllerCreate409
    >,
    { data?: ProductDraftsUserControllerCreateMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return productDraftsUserCreate(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
